import { Grid, Typography } from '@mui/material';
import React from 'react';

const FileSummary = ({
  tableValues,
  invalidRows,
  toggleIssues,
  errorsCount,
  successRecords,
  totalRecords
}) => {
  return (
    <Grid sx={{ px: 2, mt: '0.5rem', mb: 3 }} container spacing={2}>
      <Grid item xs={12}>
        <Typography
          style={{
            color: '#223354',
            fontWeight: '700',
            fontSize: '15px',
            fontFamily:
              'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
          }}
          sx={{ pb: 1 }}
          variant="h4"
        >
          File Summary
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography
          style={{
            fontSize: '12px',
            fontFamily:
              'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
          }}
        >
          Number of success records : {successRecords}
        </Typography>
      </Grid>
      <Grid display="flex" justifyContent="end" item xs={6}>
        <Typography
          style={{
            fontSize: '12px',
            fontFamily:
              'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
          }}
        >
          Number of invalid records : {errorsCount}
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography
          style={{
            fontSize: '12px',
            fontFamily:
              'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
          }}
        >
          Total records : {totalRecords}
        </Typography>
      </Grid>
      {errorsCount > 0 && (
        <Grid display="flex" justifyContent="end" item xs={6}>
          <Typography
            onClick={() => toggleIssues()}
            style={{
              cursor: 'pointer',
              textDecoration: 'underline',
              color: '#0000FF ',
              fontSize: '12px',
              fontFamily:
                'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
            }}
          >
            View Issues
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default FileSummary;
